import React from 'react'
import { FilterProps } from '../../filters'
import { css } from '@emotion/css'
import { DateFilterValue } from '../../../../../types'
import {
  DateRangeDropdown,
  DateRangeDropdownProps
} from '@contrast-security-inc/design-system-inputs'
import { useIntl } from 'react-intl'

export type DateFilters = Record<string, DateFilterValue>

export const FilterDate = ({
  filterDef: { filterKey, filterMsgId, useFilterList },
  filters,
  updateFilter
}: { filters: DateFilters } & Omit<FilterProps, 'filters' | 'resetFilter'>) => {
  const { formatMessage } = useIntl()
  const selectedRange = filters[filterKey] as DateFilterValue

  const { data } = useFilterList({ filters })

  return (
    <div
      className={css`
        margin-bottom: 16px;
      `}
    >
      <DateRangeDropdown
        testId={`date-range-dropdown-${filterKey}`}
        items={(data?.data?.filters as DateRangeDropdownProps['items']) || []}
        selectedRange={selectedRange}
        onChangeRange={(selectedItem) => {
          if (selectedItem) {
            updateFilter(filterKey, {
              id: '',
              dateRange: selectedItem
            })
          } else {
            updateFilter(filterKey, {
              id: '',
              dateRange: undefined
            })
          }
        }}
        label={formatMessage({ id: filterMsgId })}
      />
    </div>
  )
}
